import React from 'react';
import { NavLink } from 'react-router-dom';

const ClientTypesCrumb = () => <NavLink to="/admin/client-types">Client Types</NavLink>;

export default ClientTypesCrumb;
